function buildGanttChartAPI($, moment) {
	"use strict";
	
	var frenchLocale = {
		dayLabel: 'DD/MM',
		weekLabel: 'S {0}',
		dayPeriodMinWidth: 99,
		weekPeriodMinWidth: 91,
		monthPeriodMinWidth: 135
	};

	var englishLocale = {
		dayLabel: 'MM/DD',
		weekLabel: 'W {0}',
		dayPeriodMinWidth: 99,
		weekPeriodMinWidth: 94,
		monthPeriodMinWidth: 135
	};

	var germanLocale = {
		dayLabel: 'DD.MM',
		weekLabel: 'W {0}',
		dayPeriodMinWidth: 97,
		weekPeriodMinWidth: 94,
		monthPeriodMinWidth: 135,
	};

	var locales = {
		'fr': frenchLocale,
		'en': englishLocale,
		'de': germanLocale,
	};

	var daySplit = {
		name: 'day',
		momentName: 'days',
		defaultPeriodWidth: 110,
		startMoment: function(when) {
			return moment(when);
		},
		endMoment: function(when) {
			return moment(when);
		},
		getPeriodValue: function(whenMoment) {
			return whenMoment.year() * 10000 + ((whenMoment.month() + 1) * 100 + whenMoment.date());
		},
		getCaptions: function(whenMoment, lang) {
			return [whenMoment.format(lang.dayLabel), whenMoment.format('YYYY')];
		},
		getNbDays: function(whenMoment) {
			return 1;
		},
		getPeriodMinWidth: function(lang) {
			return lang.dayPeriodMinWidth;
		}
	};
	
	var weekSplit = {
		name: 'week',
		momentName: 'weeks',
		defaultPeriodWidth: 110,
		startMoment: function(when) {
			return moment(when).startOf('week');
		},
		endMoment: function(when) {
			return moment(when).endOf('week');
		},
		getPeriodValue: function(whenMoment) {
			return whenMoment.isoWeekYear() * 100 + whenMoment.isoWeek();
		},
		getCaptions: function(whenMoment, lang) {
			return [lang.weekLabel.replace('{0}', whenMoment.isoWeek().toString()), whenMoment.isoWeekYear().toString()];
		},
		getNbDays: function(whenMoment) {
			return 7;
		},
		getPeriodMinWidth: function(lang) {
			return lang.weekPeriodMinWidth;
		}
	};

	var monthSplit = {
		name: 'month',
		momentName: 'months',
		defaultPeriodWidth: 150,
		startMoment: function(when) {
			return moment(when).startOf('month');
		},
		endMoment: function(when) {
			return moment(when).endOf('month');
		},
		getPeriodValue: function(whenMoment) {
			return whenMoment.year() * 100 + whenMoment.month() + 1;
		},
		getCaptions: function(whenMoment, lang) {
			return [whenMoment.format('MMMM'), whenMoment.format('YYYY')] ;
		},
		getNbDays: function(whenMoment) {
			return whenMoment.daysInMonth();
		},
		getPeriodMinWidth: function(lang) {
			return lang.monthPeriodMinWidth;
		}
	};

	var splits = {
		'day': daySplit,
		'week': weekSplit,
		'month': monthSplit
	};

	function BBMGanttChart(target, options) {
		// Le type d'affichage choisi (semaine ou mois)
		this.split = splits[options.split];
		// la date de début de période
		this.startMoment = options.startMoment;
		// la date de fin de période
		this.endMoment = options.endMoment;
		// la liste des élément à afficher
		this.items = options.items;
		// la partie de gauche (générée par celui utilisant le composant)
		this.left = options.left;

		// la longueur d'une période
		this.parametedPeriodWidth = options.periodWidth;
		this.periodWidth = this.parametedPeriodWidth || this.split.defaultPeriodWidth;
		
		// la longueur maximale pour la partie gauche
		this.leftWidth = options.leftWidth;
		
		// le sélecteur pour la hauteur de ligne
		this.leftSelector = options.leftSelector;

		// la cible où l'on veut insérer le GanttChart
		this.target = $(target);

		// définit si on a une action sur une shape
		this.hasAShapeAction = options.hasAShapeAction;

		// on crée l'objet
		this.internalCreate();
	}

	BBMGanttChart.prototype.getPeriodDuration = function(sMoment, eMoment) {
		var start = (! sMoment) ? this.startMoment : sMoment,
			end = (! eMoment) ? this.endMoment : eMoment;
		return this.split.endMoment(end).diff(this.split.startMoment(start), this.split.momentName);
	};

	/** permet d'avoir un nombre formaté contenant l'année de la date concaténée avec la période de la date
	 * la période peut être le numéro de la semaine dans l'année si view vaut 'week'
	 * sinon le numéro du mois dans l'année
	 * 
	 * ex : view vaut 'day' pour la date 30/05/2018
	 * 			valeur retournée : 20180530
	 * 		view vaut 'week' pour la date 30/05/2018 
	 * 			valeur retournée : 201822
	 * 		view vaut 'month' pour la date 30/05/2018 
	 * 			valeur retournée : 201805
	 */ 
	BBMGanttChart.prototype.getPeriodValue = function(whenMoment) {
		return this.split.getPeriodValue(whenMoment);
	};

	BBMGanttChart.prototype.setSplit = function(name) {
		this.split = GanttChartAPI.getSplit(name || 'week');
		this.periodWidth = this.parametedPeriodWidth || this.split.defaultPeriodWidth; //this.split.name === 'week' ? 110 : 150;
		// re-dessiner la partie en-tête et détail 
		var maxWidth = this.refreshTop();
		this.refreshCenter(maxWidth);
	};

	BBMGanttChart.prototype.setPeriod = function(periodMoment) {
		this.startMoment = periodMoment.start;
		this.endMoment = periodMoment.end;
		// re-dessiner la partie en-tête et détail
		var maxWidth = this.refreshTop();
		this.refreshCenter(maxWidth);
	};

	BBMGanttChart.prototype.setPeriodWidth = function(periodWidth) {
		this.periodWidth = periodWidth;
		
		//re-dessiner la partie en-tête et détail 
		var maxWidth = this.refreshTop();
		this.refreshCenter(maxWidth);
	};

	BBMGanttChart.prototype.getItems = function() {
		return this.items;
	};

	BBMGanttChart.prototype.setItems = function(items) {
		this.items = items;
		// re-dessiner les parties gauche et détail
		this.refreshLeft();
		this.refreshCenter();
	};

	BBMGanttChart.prototype.setLeft = function(data) {
		this.left = data;
		// re-dessiner les parties gauche et détail
		this.refreshLeft();
		this.refreshCenter();

	};
	
	BBMGanttChart.prototype.setHasAShapeAction = function(hasAShapeAction) {
		this.hasAShapeAction = hasAShapeAction;
		this.internalRefreshShapeCursor();
	};
	
	BBMGanttChart.prototype.setLeftWidth = function(data) {
		this.leftWidth = data;
		var width = this.leftWidth + 'px';
		this.target.find('.left').css('width', width);
		this.target.find('.top').css('margin-left', width);
		this.target.find('.center').css('left', width);
		this.target.find('.center').css('width', 'calc(100% - ' + width +')');
		this.refresh();
	};

	BBMGanttChart.prototype.internalRefreshShapeCursor= function() {
		if (this.hasAShapeAction)
			this.target.find('div.shape').css('cursor', 'pointer'); 
	};
	
	BBMGanttChart.prototype.internalCreate = function() {
		var div = $('<div class="ganttchart" />').addClass(this.split.name).appendTo(this.target.empty());

		// mise en place de l'entete
		var header = $('<div class="top" />')
			.appendTo(div); 
		
		$('<div class="left" />')
			.appendTo(div);
				
		$('<div class="center" />')
			.css('top', header)
			.appendTo(div);

		var maxWidth = this.refreshTop();
		this.refreshLeft();
		this.refreshCenter(maxWidth);

		// on gère les ascenseurs
		this.target.find('.center').on('scroll', this.internalScroll.bind(this));
		// on met à jour les curseurs si besoin
		this.internalRefreshShapeCursor();
		
	};

	BBMGanttChart.prototype.refreshTop = function() {
		var div = this.target.find('.top'), // on récupère la div header
			whenMoment = moment(this.startMoment), // initialisation de la période 
			endPeriod = this.getPeriodValue(this.endMoment), //la fin de la période
			lang = GanttChartAPI.getLocale(moment.locale()),
			self = this,
			maxWidth = 0;
		
		// mettre a jour la locale de whenMoment avec la locale de moment
		whenMoment.locale(moment.locale());

		div.empty(); // on supprime le contenu de la div
		// on ajoute les cellules correspondant à la période
		do {
			var captions = self.split.getCaptions(whenMoment, lang),
				cell = $('<div />').css('width', self.periodWidth).appendTo(div);

			for (var i = 0; i < captions.length; i++) {
				var caption = captions[i];
				$('<span />').text(caption).appendTo(cell);
				if (self.periodWidth <= self.split.getPeriodMinWidth(lang))
					break;
			}
			
			whenMoment.add(1, self.split.momentName);
			maxWidth += parseInt(self.periodWidth); 
		} while (self.getPeriodValue(whenMoment) <= endPeriod);
		return maxWidth;
	};

	BBMGanttChart.prototype.refreshLeft = function() {
		var div = this.target.find('.left'), // on récupère la div itemHeader
			self = this;
					
		div.empty(); // on supprime le contenu de la div
		// pour chaque élément dans items, on génère la partie gauche
		self.items.forEach(function(item) {
			self.left(div, item);
		});

		/** on met à jour :
		 * - le height pour que la div prenne 100% de la taille parente moins la hauteur de la partie "top"
		 */ 
		div.css('height', 'calc(100% - ' + this.target.find('.top').height() + 'px)')
			.css('width', this.leftWidth + 'px');
		
		// on met à jour l'alignement à gauche pour la partie "top"
		this.target.find('.top').css('margin-left', div.width() + 'px');

	};

	BBMGanttChart.prototype.refreshCenter = function(maxWidth) {
		var div = $('<div />'),
			divLeft = this.target.find('.left'),
			self = this,
			top = divLeft.position().top + 'px', 
			center = this.target.find('.center');

		/** on met à jour :
		 * - le top de la div pour qu'elle soit alignée sur le top de left
		 * - le height pour que la div prenne 100% de la taille parente moins la position top
		 * - la longueur pour que la div prenne toute la longueur restante
		 * - la position left de la div pour qu'elle se place après la partie gauche (left)
		 */ 
		center.css('top', top)
			.css('height', 'calc(100% - ' + top)
			.css('width', 'calc(100% - ' + divLeft.width() + 'px)')
			.css('left', divLeft.width());
		
		center.empty();

		// on ajoute la div
		div.appendTo(center)
			.css('width', maxWidth);

		// la hauteur de la div (item) connue par la hauteur de ligne d'un élément dans la partie gauche (left)
		var divHeight = divLeft.find(this.leftSelector).height();

		// pour chaque éléments dans item, on génère la cellule correspondantes
		self.items.forEach(function(item, index) {
			// on définit la position top de la nouvelle ligne. elle correspondra au top de la div parente au quel on ajoutera 20px par item
			top = (divHeight * index) + 'px';
			// on dessine chaque shapes
			item.shapes.forEach(function(shape, shapeIndex) {
				// avant de dessiner la zone, on vérifie que les dates sont dans la période. // OPTIONNEL SI les items passés sont filtrés sur la périodes.
				if ((shape.startMs && shape.startMs > self.endMoment) || (shape.endMs && shape.endMs < self.startMoment)) {
					$('<div />').addClass('shape')
						.css('top', top)
						.css('width', '1px')
						.css('left', '0px')
						.css('height', divHeight + 'px')
						.css('visibility', 'hidden')
						.appendTo(div);
					return;
				}
					
				// on récupère la position de début (left) que doit avoir la nouvelle cellule dans le document
				// pour cela on prend en compte la position left de la div parente.
				// et en partant du début de la période on ajoute la longueur d'une cellule jusqu'à avoir la position correspondant à la période du "shape"
				var startMoment = (! shape.startMs || shape.startMs < self.startMoment) ? self.startMoment : moment(shape.startMs);
				var endMoment = (! shape.endMs || shape.endMs > self.endMoment) ? self.endMoment : moment(shape.endMs); 
				var left = self.getPeriodDuration(self.startMoment, startMoment) * self.periodWidth;
				var width = (self.getPeriodDuration(startMoment, endMoment) + 1) * self.periodWidth;
				
				// si on ne veut pas d'arrondi, on gère l'affichage au jour sur la période.
				if (! shape.round) {
					var split = self.split;
					// le début de la période
					var nbDaysDiff = startMoment.diff(split.startMoment(startMoment), 'days');
					/* le left va être ajusté pour prendre en compte le nombre de jour entre le début de la période et la date de début de l'évènement */
					left += nbDaysDiff * (self.periodWidth / split.getNbDays(startMoment));
					// la longueur de la période
					/*
					 * la longueur va être amputée du left sur le début de la période (left % this.periodWidth) 
					 * et sur la fin de la période du nombre de jour entre la date de fin de l'événement et de la date de fin de la période 
					 * 				(nbDaysDiff * (this.periodWidth / split.getNbDays(endMoment)))
					 */ 
					nbDaysDiff = split.endMoment(endMoment).diff(endMoment, 'days');
					width -= left % self.periodWidth + (nbDaysDiff * (self.periodWidth / split.getNbDays(endMoment)));
				}
				// creation de la cellule.
				var cell = $('<div />');
				cell.addClass('shape');
				cell.css('width', width + 'px');
				cell.css('left', left + 'px');
				cell.css('top', top);
				cell.css('background-color', shape.color);
				cell.addClass(shape.type); // le type : 'bar' ou 'line' ou etc
				// on calcule la hauteur et les marges à appliquer à la div en fonction de la hauteur des div de itemHeader
				if (shape.type === 'bar') {
					cell.css('margin', ((divHeight - 16) / 2) + 'px 0px');
				} else if (shape.type === 'line') {
					cell.css('margin', ((divHeight - 3) / 2) + 'px 0px');
				}
				cell.appendTo(div);
				cell.data('item', item)
					.prop('shapeIndex', shapeIndex);
			});
		});

		this.refresh();
		this.internalRefreshShapeCursor();
	};
	
	// définit si les scroll vont être affichés
	BBMGanttChart.prototype.refresh = function() {
		var divCenter = this.target.find('.center');

		if (divCenter.prop('scrollWidth') > divCenter.prop('offsetWidth')) { // on aura un scroll horizontal
			// on ajuste la marge de la div de gauche contenant le tableau des libellé en fonction de la largeur du scroll.
			this.target.find('.left').css('margin-bottom', '17px');
			this.target.find('.left').css('height', 'calc(100% - ' + (this.target.find('.left').position().top + 17) + 'px)');
		} else {
			this.target.find('.left').css('margin-bottom', '0px');
		}

		if (divCenter.prop('scrollHeight') > divCenter.prop('offsetHeight')) { // on aura un scroll vertical
			// on ajuste la marge de la div contenant les entêtes en fonction de la largeur du scroll.
			this.target.find('.top').css('margin-right', '17px');
		} else {
			this.target.find('.top').css('margin-right', '0px');
		}

	};

	BBMGanttChart.prototype.setLang = function(lang) {
		moment.locale(lang);

		var maxWidth = this.refreshTop();
		this.refreshCenter(maxWidth);
	};

	// on ajuste les ascenseurs des parties fixe (en-tête et détail a gauche)
	BBMGanttChart.prototype.internalScroll = function(event) {
		var scrollTop = event.target.scrollTop;
		var scrollLeft = event.target.scrollLeft;
				
		var divLeft = this.target.find('.left');
		if (divLeft.scrollTop !== scrollTop) {
			divLeft.scrollTop(scrollTop);
		}
		var divTop = this.target.find('.top');
		if (divTop.scrollLeft !== scrollLeft)
			divTop.scrollLeft(scrollLeft);
		return true;
	};

	$.fn.ganttChart = function(action, params) {
		// Récupération du BBMGanttChart
		if (typeof action === 'undefined') {
			if (this.length === 1)
				return this[0].ganttChart;
			return undefined;
		}
		// Construction
		if (typeof action === 'object') {
			var options = action;
			return this.each(function() {
				this.ganttChart = new BBMGanttChart(this, options);
			});
		}
		// Destruction
		if (action === 'destroy') {
			return this.each(function() {
				delete this.ganttChart;
				this.innerHTML = '';
			});
		}
	};

	var api = {
		// Récupération d'une locale parmi celles qui sont "enregistrées"
		getLocale: function(name) { return locales[name]; },
		// Enregistrement d'une nouvelle locale en dehors des locales supportées nativement (fr, en, de) 
		addLocale: function(name, locale) { locales[name] = locale; },
		// Récupération d'une vue parmi celles qui sont "enregistrées"
		getSplit: function(name) { return splits[name]; },
		// Enregistrement d'une nouvelle vue en dehors des vues supportées nativement (week, month) 
		addSplit: function(name, split) { splits[name] = split; }
	};

	return api;
}

var GanttChartAPI = buildGanttChartAPI(window.jQuery, window.moment);
